// extracted by mini-css-extract-plugin
module.exports = {"container":"skeletonList_container___OSjR"};